import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  country_label: {
    [LanguagesEnum.English]: 'Select country',
    [LanguagesEnum.Greek]: 'Επέλεξε χώρα',
  },
  vat_number_label: {
    [LanguagesEnum.English]: 'VAT Number',
    [LanguagesEnum.Greek]: 'Όνομα Eταιρείας',
  },
  comments_label: {
    [LanguagesEnum.English]: 'Comments',
    [LanguagesEnum.Greek]: 'Σχόλια',
  },
};

export const CanModify = {
  [SchemeTypes.EU]: (is_agent?: boolean): string[] => {
    return [
      'exclusionDetails_reason',
      'exclusionDetails_cessationDate',
      'exclusionDetails_country',
      'exclusionDetails_vatNum',
      'exclusionDetails_comments',
    ];
  },
  [SchemeTypes.NON_EU]: (is_agent?: boolean): string[] => {
    return [
      'exclusionDetails_reason',
      'exclusionDetails_cessationDate',
      'exclusionDetails_country',
      'exclusionDetails_vatNum',
      'exclusionDetails_comments',
    ];
  },
  [SchemeTypes.IOSS]: (is_agent: boolean): string[] => {
    if (is_agent) {
      return [
        'exclusionDetails_reason',
        'exclusionDetails_cessationDate',
        'exclusionDetails_country',
        'exclusionDetails_vatNum',
        'exclusionDetails_comments',
      ];
    } else {
      return [
        'exclusionDetails_reason',
        'exclusionDetails_cessationDate',
        'exclusionDetails_country',
        'exclusionDetails_vatNum',
        'exclusionDetails_comments',
      ];
    }
  },
};

export const ExclusionTypes = [
  {
    value: '1',
    label: 'I no longer supply goods/services covered by this special scheme',
  },
  {
    value: '2',
    label:
      'It is assumed that the taxable activities of the NETP covered by the special scheme have ceased',
  },
  {
    value: '3',
    label:
      'The NETP no longer meets the conditions necessary for use of the special scheme',
  },
  {
    value: '4',
    label:
      'The NETP persistently fails to comply with the rules relating to the special scheme',
  },
  {
    value: '5',
    label: 'I want to leave the special scheme voluntarily',
  },
  {
    value: '6',
    label: 'I want to be identified in another Member State',
  },
];

export default CONFIGURATION;
